import type {
  FieldResponseModelOfContentAreaResponseModel,
  FieldResponseModelOfImageResponseModel,
  FieldResponseModelOfString,
  FieldResponseModelOfXhtmlStringResponseModel,
} from '@api';

type FieldResponseTypes =
  | FieldResponseModelOfContentAreaResponseModel
  | FieldResponseModelOfImageResponseModel
  | FieldResponseModelOfString
  | FieldResponseModelOfXhtmlStringResponseModel;

export function useEpiAttrs(
  obj: FieldResponseTypes | null
): { 'data-epi-edit': string } | undefined {
  if (!obj || !obj.propertyName) return;

  const { inEditModeAndEditable } = useLiveEdit();

  if (inEditModeAndEditable.value) {
    return {
      'data-epi-edit': obj.propertyName,
    };
  }

  return;
}
